import { defineBoot } from '@quasar/app-vite/wrappers';
import smoothscroll from 'smoothscroll-polyfill';

export default defineBoot(() => {
  smoothscroll.polyfill();
});
